(() => {
  const updateDividers = (tabs, activeIndex) => {
    tabs.querySelectorAll('.mpv1-doctor-tabs__divider[data-between]').forEach((divider) => {
      const [left, right] = divider.dataset.between.split('-').map(Number);
      const visible = activeIndex !== left && activeIndex !== right;
      divider.classList.toggle('mpv1-doctor-tabs__divider--visible', visible);
    });
  };

  const init = () => {
    document.querySelectorAll('.mpv1-doctor-tabs:not([data-tabs-init])').forEach((tabs) => {
      tabs.setAttribute('data-tabs-init', '');

      updateDividers(tabs, 0);

      tabs.querySelectorAll('.mpv1-doctor-tabs__tab').forEach((btn) => {
        btn.addEventListener('click', () => {
          const index = Number(btn.dataset.tab);
          tabs.querySelectorAll('.mpv1-doctor-tabs__tab').forEach((b) => b.classList.remove('mpv1-doctor-tabs__tab--active'));
          tabs.querySelectorAll('.mpv1-doctor-tabs__panel').forEach((p) => p.classList.remove('mpv1-doctor-tabs__panel--active'));
          btn.classList.add('mpv1-doctor-tabs__tab--active');
          tabs.querySelector(`.mpv1-doctor-tabs__panel[data-panel="${index}"]`)?.classList.add('mpv1-doctor-tabs__panel--active');
          updateDividers(tabs, index);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Doctor Tabs V2 */
(() => {
  const initDtv2 = () => {
    document.querySelectorAll('.mpv1-dtv2:not([data-dtv2-init])').forEach((root) => {
      root.setAttribute('data-dtv2-init', '');

      const tabs = root.querySelectorAll('.mpv1-dtv2__tab');
      const panels = root.querySelectorAll('.mpv1-dtv2__panel');

      const activateTab = (tabId) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.dtv2Tab === String(tabId);
          tab.classList.toggle('mpv1-dtv2__tab--active', active);
          tab.setAttribute('aria-selected', String(active));
        });

        panels.forEach((panel) => {
          const active = panel.dataset.dtv2Panel === String(tabId);
          panel.classList.toggle('mpv1-dtv2__panel--active', active);
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          activateTab(tab.dataset.dtv2Tab);
        });
      });

      root.querySelectorAll('.mpv1-dtv2__faq-question').forEach((btn) => {
        btn.addEventListener('click', () => {
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          const answerId = btn.getAttribute('aria-controls');
          const answer = answerId
            ? root.querySelector(`#${answerId}`)
            : btn.nextElementSibling;

          btn.setAttribute('aria-expanded', String(!expanded));
          if (answer) answer.hidden = expanded;
        });
      });

      const firstTab = root.querySelector('.mpv1-dtv2__tab');
      if (firstTab) {
        activateTab(firstTab.dataset.dtv2Tab);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDtv2);
  } else {
    initDtv2();
  }

  document.addEventListener('shopify:section:load', initDtv2);
})();
